let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("Z68rF")).then(() => parcelRequire('7Ay5X'));